<template>
    <div>
        <b-tabs lazy card>
            <b-tab title="CUSTOMERS LIST">
                <ListCustomers />
            </b-tab>
            <b-tab title="LOCATION ANALYTICS">
                <LocationCustomers />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import ListCustomers from '@/components/Customers/ListCustomers.vue'
import LocationCustomers from '@/components/Customers/LocationCustomers.vue'

export default {
    name: "CustomersMain",
    components: {
        ListCustomers,
        LocationCustomers
    },
    data: function(){
        return {
            packet: {}
        }
    },
    created: function(){
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);

        if (!this.packet.userDetails.userrole || 
            !['admin', 'accountmanager', 'officeuser', 'officemanager', 'locationadmin', 'salesperson', 'accountuser'].includes(this.packet.userDetails.userrole)){
            localStorage.clear()
            this.$router.push("/")
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Customers/CustomerMain.vue